<template>
    <v-row justify="center">
    <v-expansion-panels accordion dark v-model="panel">
      <v-expansion-panel
        v-for="(item,i) in items"
        :key="i"
        @change="changeItem(item)"
      >
        <v-expansion-panel-header
          expand-icon="close">
          {{ item.title }}
          <template v-slot:actions>
            <v-icon >{{ icon(item) }}</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <span v-html="item.info"></span>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
  export default {
    name: 'ghExpansionItems',

    props: {
      items: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        panel: 0,
        selected: this.items[0]
      }
    },

    computed: {

    },

    methods: {
      changeItem(item) {
        if(this.selected === item) {
          this.selected = {}
        } else {
          this.selected = item
        }
      },

       icon(item) {
        return item.title === this.selected.title ? 'close' : 'add'
      }
    }
  }
</script>

<style scoped lang="sass">
  .v-expansion-panels
    background: transparent
</style>

<style lang="sass">
  .v-expansion-panel-content
    span a
      color: #ffffff
      &:hover
        color: #b3b3b3
</style>
